import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { Spinner } from "../../Feedback/Spinner/index.js";
import { SpinnerSize } from "../../Feedback/Spinner/constants.js";
import { LOADING_BUTTON_COLOR_MAP, VARIANTS } from "./types.js";
const LoadingButton = ({ variant, children, loadingPosition }) => {
  const spinnerColor = variant ? LOADING_BUTTON_COLOR_MAP[variant] : LOADING_BUTTON_COLOR_MAP[VARIANTS.PRIMARY];
  const spinner = /* @__PURE__ */ jsx(
    Spinner,
    {
      label: "Loading",
      size: SpinnerSize.Small,
      isInline: true,
      spinnerColor
    }
  );
  const shouldShowSpinnerFirst = loadingPosition === "start" || loadingPosition === "center";
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    shouldShowSpinnerFirst && spinner,
    children,
    !shouldShowSpinnerFirst && spinner
  ] });
};
export {
  LoadingButton
};
